module.exports = __webpack_public_path__ + "img/c3.671e250e.jpg";